import React, { useState, useEffect } from "react"

import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import { Box, Button, Typography } from "@material-ui/core/"
import { useDispatch, useSelector } from "react-redux"
import Logo from "../../assets/firstline_social_icon_logo.png"
import Step1Organization from "./steps/Step1Organization"
import Step2PrimaryContact from "./steps/Step2PrimaryContact"
import Step3OrganizationSize from "./steps/Step3OrganizationSize"
import Step4Payment from "./steps/Step4Payment"
import { openSnackBar } from "actions/snack-bar"
import LinearProgress from "@material-ui/core/LinearProgress"
import options from "./subOptions"
import { createOrg } from "actions/organization"
import { useDebounce } from "use-lodash-debounce"
import {
  checkOrgSubdomain,
  addStripeToOrg,
  chargeOrgForSubscription
} from "actions/organization"
import { useStripe, useElements } from "@stripe/react-stripe-js"
import CreateOrganizationBackgroundImage from "../../assets/create-organization-dialog-background.png"
import LoaderButton from "../../components/LoaderButton"
import API from "store/api"
import { forEach } from "lodash"

const OrganizationSignUp = ({ classes }) => {
  const stripe = useStripe()
  const elements = useElements()
  const [formRef, setFormRef] = useState(null)
  const [currentStep, setCurrentStep] = useState(0)
  const dispatch = useDispatch()
  const authenticatedUser = useSelector(
    state => state.authentication.authenticatedUser
  )
  const authentication = useSelector(state => state.authentication)
  const [working, setWorking] = useState(false)
  const [completed, setCompleted] = useState(0)
  const [validSubdomain, setValidSubdomain] = useState(false)
  const [formState, setFormState] = useState({
    organizationName: "",
    organizationSubDomain: "",
    firstName: "",
    lastName: "",
    address: null,
    phone: "",
    email: "",
    plan: 3,
    agreementChecked: false,
    coupon: null,
    groupCode: "",
    groupCodeId: ""
  })
  const bouncedSubdomain = useDebounce(formState.organizationSubDomain, 200)
  const setFormData = e => {
    setFormState(oldState => ({
      ...oldState,
      [e.target.name]: e.target.value
    }))
  }
  //creating a local state in order to populate slider
  //list is created by deconstructing the information from rawOptions
  const [dyanmicList, setDynamicList] = useState([])
  //creating an API call to populate raw options
  useEffect(() => {
    API.get("/stripe/listPlans")
      .then(res => {
        //pushing information into an array to make it easier to manipulate
        let tempArr = res.body.plans
        //setting the index outside of the array to make it easier to call in the loop
        //change 8 to whatever the amount of products you want to be displayed
        //HOWEVER the products have to be continuous in the list
        let setOptions = tempArr.length - 8
        //pushing all the deconstructed objects into an array to be set to local state
        let tempOptionsArr = []
        //only puts the bottom 8 subscriptions into the array, since everything else will be a promocode of some sort
        //keeping track of what the id should be internally
        let tracker = 1
        for (let index = setOptions; index < tempArr.length; index++) {
          //manipulating amount to be used to calculate monthly price and whole price with decimals
          let tempNumber = tempArr[index].amount
          let tempNumberToString = tempNumber.toString()
          let tempNumberToWhole = tempNumberToString.substring(
            0,
            tempNumberToString.length - 2
          )
          //deconstructed object gathered from the response body
          const tempOption = {
            id: tracker,
            value: tracker,
            label: tempArr[index].nickname,
            price: (tempNumberToWhole / 12).toFixed(2),
            //passing in the nickname to be used for the explanation on payment page
            explanation: `This subscription level will allow up ${tempArr[index].nickname} organization members to create a FirstLine Social account. Organizations will be billed annually.`,
            //adding decimal to full price
            total:
              tempNumberToString.slice(0, tempNumberToString.length - 2) +
              "." +
              tempNumberToString.slice(tempNumberToString.length - 2),
            plan: tempArr[index].id
          }
          //adding each object to the temporary array
          tempOptionsArr.push(tempOption)
          tracker += 1
        }
        //pushing the full array into local state
        setDynamicList(tempOptionsArr)
      })
      .catch(err => {
        console.log(err)
      })
  }, [])
  //temporary placement of the components layout/steps
  const components = [
    {
      currentStepComponent: 0,
      title: "Step 1",
      subtitle: "Please tell us about your organization",
      render: data => <Step1Organization data={data} />
    },
    {
      currentStepComponent: 1,
      title: "Step 2",
      subtitle:
        "The person added here will be FirstLine Social’s point of contact for your business. Please choose someone who will be communicating with us on your company’s behalf; generally your Public Information Officer or Social Media Specialist.",
      render: data => <Step2PrimaryContact data={data} />
    },
    {
      currentStepComponent: 2,
      title: "Step 3",
      subtitle: "Tell us more about your organization",
      render: data => (
        <Step3OrganizationSize data={data} options={dyanmicList} />
      )
    },

    {
      currentStepComponent: 3,
      title: "Step 4",
      subtitle: "Subscription information",
      render: data => <Step4Payment data={data} options={dyanmicList} />
    }
  ]
  const handleClose = () => {
    setTimeout(() => {
      setCurrentStep(0)
    }, 500)
  }

  const handleBack = () => {
    if (currentStep !== 0) {
      setCurrentStep(currentStep - 1)
      setFormData({
        target: {
          value: false,
          name: "agreementChecked"
        }
      })
    }
    if (currentStep === 0) {
      handleClose()
    }
  }

  const getStripeToken = async () => {
    if (!stripe || !elements) {
      console.log("no stripe")
      return
    }
    const cardElement = elements.getElement("card")

    // Use your card Element with other Stripe.js APIs
    const { error, source } = await stripe.createSource(cardElement)

    if (error) {
      throw error
    }
    return source.id
  }

  const handleSubmitForm = () => {
    formRef.current.handleSubmit()
  }

  let formSubmit = () => setCurrentStep(currentStep + 1)
  if (currentStep === 0 && !validSubdomain) {
    formSubmit = () => {
      dispatch(openSnackBar({ message: "Subdomin is not available" }))
    }
  } else if (currentStep === 2 && formState.plan === null) {
    formSubmit = () => {
      dispatch(openSnackBar({ message: "Please, select a plan" }))
    }
  } else if (currentStep === 3 && formState.agreementChecked === "false") {
    formSubmit = () => {
      dispatch(
        openSnackBar({ message: "Please, accept the terms & agreements" })
      )
    }
  } else if (currentStep === 3) {
    if (formState.agreementChecked === "true") {
      if (formState.groupCode) {
        formSubmit = () => {
          setWorking(true)
          dispatch(
            createOrg({
              email: formState.email,
              phone: formState.phone,
              address: JSON.stringify(formState.address),
              contact_first_name: formState.firstName,
              contact_last_name: formState.lastName,
              name: formState.organizationName,
              subdomain: formState.organizationSubDomain,
              group_code_id: formState.groupCodeId,
              plan: null
            })
          )
            .then(() => {
              const host = window.location.host.split(".")
              const subdomain = formState.organizationSubDomain
              const userId = authenticatedUser.id
              const token = authentication.token
              if (host.length === 3) {
                window.location.href = `http://${subdomain}.${host[1]}.${host[2]}/admin/settings?token=${token}&user=${userId}`
              } else {
                window.location.href = `http://${subdomain}.${host[0]}.${host[1]}/admin/settings?token=${token}&user=${userId}`
              }
            })
            .catch(err => {
              console.log(err)
              if (err.message) {
                dispatch(openSnackBar({ message: err.message }))
              } else {
                dispatch(openSnackBar({ message: err }))
              }
            })
            .finally(() => {
              setWorking(false)
            })
        }
      } else {
        formSubmit = () => {
          let stripeToken = ""
          setWorking(true)
          let orgId = null
          getStripeToken()
            .then(token => {
              // console.log(formState, options)
              stripeToken = token
              //needs to be searching through the dynamic list instead of hard coded options
              const plan = dyanmicList.find(
                x => Number(x.id) === Number(formState.plan)
              ).plan
              console.log("formstate plan: " + formState.plan)
              console.log("option plan: " + plan)
              return dispatch(
                createOrg({
                  email: formState.email,
                  phone: formState.phone,
                  address: JSON.stringify(formState.address),
                  contact_first_name: formState.firstName,
                  contact_last_name: formState.lastName,
                  name: formState.organizationName,
                  subdomain: formState.organizationSubDomain,
                  plan,
                  group_code_id: null
                })
              )
            })
            .then(org => {
              orgId = org.orgId
              return dispatch(addStripeToOrg(orgId, stripeToken))
            })
            .then(() => {
              return dispatch(
                chargeOrgForSubscription(
                  orgId,
                  formState.coupon ? formState.coupon.id : ""
                )
              )
            })
            .then(() => {
              const host = window.location.host.split(".")
              const subdomain = formState.organizationSubDomain
              const userId = authenticatedUser.id
              const token = authentication.token
              if (host.length === 3) {
                window.location.href = `http://${subdomain}.${host[1]}.${host[2]}/admin/settings?token=${token}&user=${userId}`
              } else {
                window.location.href = `http://${subdomain}.${host[0]}.${host[1]}/admin/settings?token=${token}&user=${userId}`
              }
            })
            .catch(err => {
              if (
                err.response &&
                err.response.body &&
                err.response.body.error
              ) {
                const errorMessage = err.response.body.error
                if (
                  errorMessage ===
                  "This customer has no attached payment source or default payment method."
                ) {
                  dispatch(openSnackBar({ message: "Error charging card" }))
                } else {
                  dispatch(openSnackBar({ message: err.response.body.error }))
                }
              } else if (err && err.response && err.response.body) {
                dispatch(openSnackBar({ message: err.response.body.message }))
              } else if (err && err.message) {
                dispatch(openSnackBar({ message: err.message }))
              } else if (typeof err !== "string") {
                dispatch(openSnackBar({ message: err.toString() }))
              } else {
                dispatch(openSnackBar({ message: err }))
              }
            })
            .finally(() => {
              setWorking(false)
            })
        }
      }
    } else {
      formSubmit = () =>
        dispatch(
          openSnackBar({
            message:
              "Please check the terms and conditions before creating your organization"
          })
        )
    }
  }
  // set completed to precentage of form done
  useEffect(() => {
    setCompleted(() => {
      return 100 * ((currentStep + 1) / components.length)
    })
  }, [currentStep])

  useEffect(() => {
    setValidSubdomain(false)
    dispatch(checkOrgSubdomain(formState.organizationSubDomain))
      .then(() => {
        if (formState.organizationSubDomain !== "") {
          formRef.current.setStatus(undefined)
        }
        setValidSubdomain(true)
      })
      .catch(() => {
        if (formState.organizationSubDomain !== "") {
          formRef.current.setStatus({
            organizationSubDomain: "Subdomain not available."
          })
        }
        setValidSubdomain(false)
      })
  }, [bouncedSubdomain])

  return (
    <Box>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        className={classes.OrganizationSignUPContainer}
        style={{
          backgroundImage: `url(${CreateOrganizationBackgroundImage})`
        }}
      >
        <Box className={classes.informationContainer}>
          <LinearProgress
            variant="determinate"
            value={completed}
            className={classes.linerProgressContainer}
          />
          <Box display="flex" justifyContent="center">
            <img
              src={Logo}
              alt="FirstLine Social Logo"
              className={classes.logoContainer}
            />
          </Box>
          <Box className={classes.contentContainer}>
            {components
              .filter(element => element.currentStepComponent === currentStep)
              .map((component, i) => {
                return (
                  <Box key={i}>
                    <Typography variant="h2" className={classes.title}>
                      {component.title}
                    </Typography>
                    <Typography variant="h6" className={classes.subtitle}>
                      {component.subtitle}
                    </Typography>
                    <Box className={classes.stepsContainer}>
                      {component.render({
                        formState,
                        setFormRef,
                        formSubmit,
                        setFormData,
                        stripe,
                        elements
                      })}
                    </Box>
                  </Box>
                )
              })}
          </Box>
          <Box
            className={classes.buttonsContainer}
            display="flex"
            justifyContent="flex-end"
          >
            {currentStep !== 0 && (
              <Button onClick={handleBack}>
                <span className={classes.cancelButtonText}>back</span>
              </Button>
            )}
            <LoaderButton
              working={working}
              classes={{
                button: classes.buttonNext,
                buttonProgress: classes.buttonProgress
              }}
              onClick={handleSubmitForm}
            >
              {currentStep === 3 ? "create" : "next"}
            </LoaderButton>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default withStyles(styles)(OrganizationSignUp)



// WEBPACK FOOTER //
// ./src/pages/OrganizationSignUp/index.js